import Echo from 'laravel-echo';
require('pusher-js');

import TenantService from '@/services/TenantService';
import UserService from '@/services/UserService';
import ApiService from '@/services/ApiService';

import AppEvent from '@/models/AppEvent';
import Shift from '@/models/Shift';

export default {
    created() {
        this.eventBus.$on('app-initialized', () => {
            this.initWebsockets()
        });
    },

    data: () => {
        return {
            websocketChannel: null,
            echo: null
        };
    },

    watch: {
        tenant(val) {
            if(this.echo) {
                this.echo.reload();
                this.joinChannels();
            }
        }
    },

    methods: {
        /**
         * Initialize Laravel Echo with Soketi (bypasses Pusher but uses Pusher API)
         */
        initWebsockets() {
            let options = {
                broadcaster: 'pusher',
                key: process.env.VUE_APP_PUSHER_APP_KEY,
                wsHost: process.env.VUE_APP_PUSHER_HOST,
                wsPort: process.env.VUE_APP_PUSHER_PORT,
                wssPort: process.env.VUE_APP_PUSHER_PORT,
                forceTLS: false,
                encrypted: true,
                disableStats: true,
                enabledTransports: ['ws', 'wss'],
                // auth: {
                //     headers: {
                //         TnAuthorization: 'Tenant ' + TenantService.getToken(),
                //         Authorization: 'Bearer ' + UserService.getToken()
                //     }
                // },
                // authEndpoint: apiEndpoint + '/broadcasting/auth',
                cluster: 'eu'
            }

            // Setup Laravel Echo
            this.echo = new Echo(options);

            this.echo.reload = function() {
                this.disconnect();
                this.options.auth = {
                    headers: {
                        TnAuthorization: 'Tenant ' + TenantService.getToken(),
                        Authorization: 'Bearer ' + UserService.getToken()
                    }
                };
                this.connect();
            };

            // Set Socket Id Header
            this.echo.connector.pusher.connection.bind('connected', () => {
                ApiService.setSocketIdHeader(this.echo.socketId())
            });

            this.echo.connector.pusher.connection.bind('disconnected', () => {
                ApiService.removeSocketIdHeader()
            });

            // Join Channels
            this.joinChannels();
        },

        /**
         * Subscribe to WebSocket channels
         */
        joinChannels() {
            if (!this.tenant) {
                if (this.websocketChannel) {
                    this.echo.leaveChannel(this.websocketChannel);
                    this.websocketChannel = null;
                }
                return;
            }

            this.websocketChannel = `notifications.${this.tenant.hash}`;

            this.echo.channel(this.websocketChannel).listen('Notification', async event => {
                AppEvent.handle(event)
            });
        }
    }
}
